var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.527 8.77C17.322 6.345 13.667 3.782 10 3.833 6.333 3.781 2.678 6.346.473 8.77a1.843 1.843 0 000 2.457c2.179 2.399 5.783 4.94 9.393 4.94h.257c3.622 0 7.225-2.541 9.406-4.941a1.842 1.842 0 00-.002-2.456zM6.167 10A3.833 3.833 0 1110 13.833 3.833 3.833 0 016.167 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333 10a1.667 1.667 0 103.334 0 1.667 1.667 0 10-3.334 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d5e74d06.svg";
export { ForwardRef as ReactComponent };